import clsx from "clsx";
import React from "react";
import "./settingsContainerTitle.scss";

interface ISettingsContainerTitleProps extends React.ComponentPropsWithoutRef<"h2"> { }

export const SettingsContainerTitle = (props: ISettingsContainerTitleProps) => {
    return <h2 {...props} className={clsx("settings-container-title", props.className)} />;
};
